module.exports = __webpack_public_path__ + "static/media/limits_of_freedom.bff27b17.doc";